import React, { useState } from 'react';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import DeleteAppointmentModal from '../modals/deleteAppointmentModal';
import { Redo, Trash } from 'lucide-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import VisitSummaryModal from '../modals/VisitsModal';
import Spinner1 from '../common/spinners';
import { truncateText } from "../../utils/utilities";
import moment from 'moment';


const VisitSummaryTable = ({ data, loading }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [rescheduleDate, setRescheduleDate] = useState(new Date());
  const [rescheduleTime, setRescheduleTime] = useState("");
  const [rescheduleReason, setRescheduleReason] = useState("");

  const [selectedDate, setSelectedDate] = useState()
  const [selectedData, setSelectedData] = useState()
  const [selectedVitals, setSelectedVitals] = useState();
 
  const openDeleteModal = (item) => {
    setShowDeleteModal(true);
    setSelectedAppointment(item);
  };

  // const openDetailsModal = (item) => {
  //   setSelectedAppointment(item);
  //   setShowDetailsModal(true);
  // };

  const filteredVitals = data?.vitals?.map(entry => ({
    created_at: entry.created_at,
    d: entry.data,
    // data: entry?.data?.find(item => item.createdAt?.startsWith(entry.created_at))
  }));
  
   // Open Modal and Set Data
   const openDetailsModal = (date) => {
    // const fullData = data?.diagnosis?.find(item => item.createdAt === date)?.data || [];
    const fullData = data?.diagnosis
      .filter(item => item.date === date)
      .flatMap(item => item.data);

    const vitalsData = data?.vitals
    .find(item => item?.created_at?.split("T")[0] === date)

    if (vitalsData) {
     const dataWithMatchingCreatedAt = vitalsData.data.filter(
        dataItem => dataItem.createdAt.split("T")[0] === vitalsData.created_at.split("T")[0]
      )
      // console.log("in-built",dataWithMatchingCreatedAt)
      setSelectedVitals(dataWithMatchingCreatedAt)
    }

    // console.log("fullData", fullData)

    setSelectedDate(date);
    setSelectedData(fullData);
    setSelectedVitals(filteredVitals)
    setShowSummaryModal(true);
  };

  // console.log("selectedD", selectedData)

 
  const filteredData = data?.diagnosis?.map(entry => ({
    date: entry.date,
    data: entry.data.find(item => item.createdAt.startsWith(entry.date))
  }));

  // console.log("filteredDisplay",filteredData)

  

  // console.log("details...",filteredVitals);

//search filter
  const SearchedData = filteredData?.filter(
    (item) =>
      item.data?.diagnosis?.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.data?.diagnosis_type?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(SearchedData?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = SearchedData?.slice(indexOfFirstItem, indexOfLastItem);

  
// console.log(data,'---------------------data') -
  return (
    <div className=' w-100'>
      <Form.Control
        type="text"
        placeholder="Search..."
        className="mb-3 mx-4"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ width: '250px' }}
      />
      <div>
      {
        loading ? <div className=' w-100 d-flex justify-content-center'><Spinner1/></div> :
        !loading && !SearchedData?.length ?
          
          <div className='w-100 d-flex justify-content-center'>No Result Found</div>
        :
         <div style={{overflowX:'auto'}}>
          <table  style={{minWidth:'600px'}} striped hover className="align-middle w-100">
            {/* Table Header */}
            <thead className=' px-3'>
              <tr className=' px-3'>
                <th  style={{ paddingLeft: '20px' }}>Date</th>
                {/* <th>Consultant</th> */}
                <th>Consultant</th>
                <th>Diagnosis</th>
                <th>Type</th>
                {/* <th>Comment</th> */}
                <th>Status</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className=' px-5'>
              { 
              currentItems?.map(({date, data}) => (
                <tr 
                  key={date} 
                  onClick={() => openDetailsModal(date)} 
                // onClick={() => openSummaryModal(item)}
                  className="py-3 border-bottom" 
                  style={{ cursor: 'pointer', height: '65px' }} 
                >
                  <td className="py-3 px-3">
                    <div className="d-flex align-items-center gap-2">
                      <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                        <i className="ri-information-line"></i>
                      </div>
                      <div>
                      <h6>{moment(data?.createdAt).format('dddd')}</h6>
                      <h6 className="mb-0 text-success">{moment(data?.createdAt).format('Do MMM, yyyy')}</h6>

                      </div>
                    </div>
                  </td>

                  <td>
                    <div className='d-flex align-items-center gap-2'>
                      <div className="avatar">
                        <span className="avatar-initial"><i class="ri-user-line"></i></span>
                      </div>
                      <div>
                        {data?.diagnosis.createdBy && Array.isArray(data?.diagnosis.createdBy) ? (
                            data.diagnosis.createdBy.map((d, i) => (
                              <h6 key={i}>{d}</h6>
                            ))
                          ) : (
                            <h6 className='text-capitalize'>Dr.{data.diagnosis.createdBy?? '---'}</h6>
                          )}
                      </div>
                    </div>
                  </td>
                  <td className="py-3">{truncateText(`${data?.diagnosis.description?? "---"}`, 15)}</td>

                  <td className="py-3">{truncateText(`${data?.diagnosis_type?? "---"}`, 15)}</td>
                  {/* <td className="py-3 text-capitalize">{truncateText(`${data?.diagnosis.createdBy?? "---"}`, 15)}</td> */}
                  <td className="py-3 text-capitalize">{data?.status === "Active"? <span className='badge bg-success'>Active</span> : <span className='badge bg-danger'>In-Active</span>}</td>
                
                </tr>
              ))} 
            </tbody>
          </table>
         </div>

      }
  </div>
      {
        SearchedData?.length && !loading ? (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <Button
              variant="light"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Previous
            </Button>
            <span>Page {currentPage} of {totalPages}</span>
            <Button
              variant="light"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </Button>
          </div>
        )
        :
        (<></>)
      }
      {/* <div className="d-flex justify-content-between align-items-center mt-3">
          <Button
          variant="light"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
          >
          Previous
          </Button>
          <span>Page {currentPage} of {totalPages}</span>
          <Button
          variant="light"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
          >
          Next
          </Button>
      </div> */}

 
       {/* Visit Summary Modal */}
       <VisitSummaryModal
        show={showSummaryModal} 
        onClose={() => setShowSummaryModal(false)}
        selectedDate = {selectedDate}
        selectedData = {selectedData}
        selectedVitals = {selectedVitals} 
      />

      {/* Delete Appointment Modal */}
      <DeleteAppointmentModal show={showDeleteModal} setShow={setShowDeleteModal} data={selectedAppointment} />
    </div>
  );
};
export default VisitSummaryTable;